import { ProviderCategory } from './emailProvider';

export type ProviderHintConfig = {
  collapsedLabel: string;
  title: string;
  // Body values use **double asterisks** around words to render them bold.
  body: string;
};

export const PROVIDER_HINT_CONFIG: Record<ProviderCategory, ProviderHintConfig> = {
  microsoft_consumer: {
    collapsedLabel: 'email_hint_collapsed_ms',
    title: 'email_hint_ms_title',
    body: 'email_hint_ms_body',
  },
  yahoo_family: {
    collapsedLabel: 'email_hint_collapsed_yahoo',
    title: 'email_hint_yahoo_title',
    body: 'email_hint_yahoo_body',
  },
  gmail: {
    collapsedLabel: 'email_hint_collapsed_gmail',
    title: 'email_hint_gmail_title',
    body: 'email_hint_gmail_body',
  },
  zoho: {
    collapsedLabel: 'email_hint_collapsed_zoho',
    title: 'email_hint_zoho_title',
    body: 'email_hint_zoho_body',
  },
  apple: {
    collapsedLabel: 'email_hint_collapsed_apple',
    title: 'email_hint_apple_title',
    body: 'email_hint_apple_body',
  },
  other: {
    collapsedLabel: 'email_hint_collapsed_other',
    title: 'email_hint_other_title',
    body: 'email_hint_other_body',
  },
};
